// eslint-disable-next-line no-restricted-exports
export { default } from './Heading';
export * from './Heading';
